export default function () {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 21C15.2091 21 17 19.1532 17 16.875C17 13.025 13 10 13 10C13 10 9 13.025 9 16.875C9 19.1532 10.7909 21 13 21Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 11C7.88072 11 9 9.82475 9 8.375C9 5.925 6.5 4 6.5 4C6.5 4 4 5.925 4 8.375C4 9.82475 5.11928 11 6.5 11Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 9C18.1046 9 19 7.99265 19 6.75C19 4.65 17 3 17 3C17 3 15 4.65 15 6.75C15 7.99265 15.8954 9 17 9Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
